import { type FormEvent, useState } from 'react';
import { Link, Navigate, useLocation, useNavigate } from 'react-router-dom';
import { track } from '../analytics.js';
import { ApiError } from '../api/client.js';
import { useSession } from '../api/session.js';

export function LoginPage() {
  const { user, loading, signIn } = useSession();
  const navigate = useNavigate();
  const location = useLocation();
  // Dokąd użytkownik zmierzał, zanim odbiła go bramka logowania. Bez tego
  // kliknięcie linku zaproszenia bez sesji lądowałoby w lobby zamiast w partii.
  const from = (location.state as { from?: string } | null)?.from ?? '/';
  const [login, setLogin] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  if (loading) return <p className="app__status">Sprawdzanie sesji…</p>;
  if (user) return <Navigate to={from} replace />;

  async function submit(event: FormEvent) {
    event.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await signIn(login, password);
      navigate(from, { replace: true });
    } catch (problem) {
      setError(problem instanceof ApiError ? problem.message : 'Nie udało się zalogować');
      const code = problem instanceof ApiError ? problem.code : 'UNKNOWN';
      track('error_shown', { props: { code } });
    } finally {
      setBusy(false);
    }
  }

  return (
    <form className="card card--narrow" onSubmit={submit}>
      <h2 className="hand">Zaloguj się</h2>
      <label className="field">
        <span>Nick albo e-mail</span>
        <input
          value={login}
          onChange={(event) => setLogin(event.target.value)}
          autoComplete="username"
          required
        />
      </label>
      <label className="field">
        <span>Hasło</span>
        <input
          type="password"
          value={password}
          onChange={(event) => setPassword(event.target.value)}
          autoComplete="current-password"
          required
        />
      </label>
      {error && (
        <p className="alert" role="alert">
          {error}
        </p>
      )}
      <button type="submit" className="btn btn--primary" disabled={busy}>
        {busy ? 'Logowanie…' : 'Wejdź'}
      </button>
      <p className="app__note">
        Nie masz konta? <Link to="/rejestracja">Załóż je linkiem zaproszenia</Link> od znajomego.
      </p>
      {/*
        Konta gościa (docs/08-decyzje.md #19) są zbudowane i przetestowane po stronie
        serwera (POST /api/auth/guest), ale świadomie nieupublicznione — ten przycisk
        jest tylko zapowiedzią, celowo bez onClick i bez wywoływania API.
      */}
      <button
        type="button"
        className="btn btn--ghost"
        disabled
        title="Wkrótce — konta gościa nie są jeszcze dostępne"
      >
        Zagraj jako gość (wkrótce)
      </button>
    </form>
  );
}
